module.exports = __webpack_public_path__ + "static/img/interactive-img5.b85a7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/interactive-img5.jpg
// module id = 331
// module chunks = 64